import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import './AlarmsBarChart.scss';
import { useTranslation } from 'react-i18next';

const data = [
    { date: "02/25", Minor: 2, Warning: 1, Critical: 1},
    { date: "03/25", Minor: 3, Warning: 2, Critical: 2},
    { date: "04/25", Minor: 3, Warning: 2, Critical: 1},
    { date: "05/25", Minor: 3, Warning: 2, Critical: 2},
    { date: "06/25", Minor: 4, Warning: 2, Critical: 2},
    { date: "07/25", Minor: 3, Warning: 2, Critical: 1},
];

const AlarmsBarChart = (props: {dark: boolean} ) => {
    const { t } = useTranslation()

    return (
        <div className="rounded-1 p-2 pe-4 d-flex align-items-center justify-content-center" 
                style={{ backgroundColor: 'var(--background-secondary)', height: '244px', color: 'var(--text-primary)',boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)' }}>
            <ResponsiveContainer width="100%" height={200}>
                <BarChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" vertical={false} />
                    <XAxis dataKey="date" stroke={props.dark ? '#fff' : '#000'} />
                    <YAxis stroke={props.dark ? '#fff' : '#000'} />
                    <Tooltip 
                        formatter={(value, name) => [value, t('Severity'+name)]}
                    />
                    <Legend
                        wrapperStyle={{ color: "#fff" }}
                        iconType="square"
                        iconSize={10}
                        formatter={(value) => t('Severity'+value)}
                    />
                    <Bar dataKey="Critical" stackId="a" fill="#e74c3c" barSize={30} />
                    <Bar dataKey="Warning" stackId="a" fill="#f39c12" barSize={30}/>
                    <Bar dataKey="Minor" stackId="a" fill="#f1c40f" barSize={30} radius={[5, 5, 0, 0]}/>
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default AlarmsBarChart;
